import React, {useEffect, useState} from 'react';
import ReactTooltip from 'react-tooltip';
import AdminGallery from './admin/AdminGallery';
import Login from './admin/Login';
import AuthService from './admin/services/auth.service';
import TokenService from './admin/services/token.service';
import './App.css';

const AdminPanel = (props) => {
  const [currentUser, setCurrentUser] = useState(undefined);
  const [loading, setLoading] = useState(true);
  
  useEffect(()=> {

    checkUser();
    setLoading(false);
    window.addEventListener('storage', checkUser)
    
    return (()=> {
      window.removeEventListener('storage', checkUser)
    })
  }, [])
  
  const checkUser = () => {
    const user = TokenService.getUser();
      if (user) {
        setCurrentUser(user);
      }
  }

  const logIn = () => {
    const user = TokenService.getUser();
    if (user) {
      setCurrentUser(user);
    }
  }

  const logOut = () => {
    AuthService.logout();
    setCurrentUser(undefined);
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="admin-container">
          <div className="header-container">
            <div className="admin-header-text" style={{flex: 1, justifyContent: 'center'}}>
              Subaru Adventure On Parks Admin Panel
            </div>
          </div>
          <div className="admin-body-container">
              <div className="admin-grid-container">
                <div style={{display: 'flex', minHeight: 400, flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                  Loading...
                </div>
              </div>
          </div>
      </div>
      )
    }
    else if(!currentUser) {
      return (
        <div className="admin-container">
          <div className="header-container">
            <div className="admin-header-text" style={{flex: 1, justifyContent: 'center'}}>
              Subaru Adventure On Contest Admin Panel
            </div>
          </div>
          <div className="admin-body-container">
              <div className="admin-login-container">
                  <Login loginCallback={logIn}/>
              </div>
          </div>
      </div>
      )
    } else {
        return (
          <div className="admin-container">
              <div className="header-container">
                <div className="admin-header-text" style={{flex: 1, marginLeft: 80, justifyContent: 'center'}}>
                  Subaru Adventure On Contest Admin Panel
                </div>
                <div 
                  className="admin-auth-text"
                  onClick={()=> {
                    logOut();
                  }}
                >
                  Log out
                </div>
              </div>
              <div className="admin-body-container">
                  <div className="admin-grid-container">
                      <AdminGallery/>
                  </div>
              </div>
          </div>
        )
    }
  }

  return (
    <>
      {renderContent()}
      <ReactTooltip className="tooltip" effect="solid" type="light"/>
    </>
  )

}

export default AdminPanel;